import {BaseMapData} from './BaseMapData'
import {StoreMapType} from '../entity_datas/StoreEnums'
import {StoreExpansionType, LobbyImage, MapSettingEnum, ModeSettingEnum, ScenarioSettingEnum} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'

export class MapDataClassic4P extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.Classic4P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.classic.4P.title'}
    image = LobbyImage.MapClassic4PPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P, ModeSettingEnum.ColonistRush4P]
    includeInFreeMapRotationIfActive: false
    isActive = true
    numberOfLandTiles = 19

    scenario = ScenarioSettingEnum.None
}

export class MapDataTutorialClassic4P extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.TutorialClassic4P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.classic.tutorial4P.title'}
    image = LobbyImage.MapClassic4PPreview
    compatibleGameModes = [ModeSettingEnum.TutorialClassic4P, ModeSettingEnum.ServerStressTestClassic4P, ModeSettingEnum.BeginnerModeClassic4P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 19

    scenario = ScenarioSettingEnum.None
}

export class MapDataCampaignLevel1 extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = []
    mapEnum = MapSettingEnum.CampaignLevel1
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.classic.tutorial4P.title'}
    image = LobbyImage.MapClassic4PPreview
    compatibleGameModes = [ModeSettingEnum.BeginnerModeClassic4P]
    includeInFreeMapRotationIfActive = false
    isActive = false
    numberOfLandTiles = 19

    scenario = ScenarioSettingEnum.None
}

export class MapDataCampaignLevel2 extends MapDataCampaignLevel1 {
    mapEnum = MapSettingEnum.CampaignLevel2
}

export class MapDataClassic4PRandom extends BaseMapData {
    premiumExpansionAccess = []
    premiumMapAccess = [StoreMapType.Classic4PRandom]
    mapEnum = MapSettingEnum.Classic4PRandom
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.classic.random4P.title'}
    image = LobbyImage.MapRandomBasePreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P, ModeSettingEnum.ColonistRush4P]
    includeInFreeMapRotationIfActive: false
    isActive = true
    numberOfLandTiles = 19

    scenario = ScenarioSettingEnum.None
}

export class MapDataClassic56P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Classic56P, StoreExpansionType.CitiesAndKnights56P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.Classic56P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.classic.56P.title'}
    image = LobbyImage.MapClassic56PPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P, ModeSettingEnum.ColonistRush4P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 30

    scenario = ScenarioSettingEnum.None
}

export class MapDataClassic78P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Classic78P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.Classic78P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.classic.78P.title'}
    image = LobbyImage.MapClassic78PPreview
    compatibleGameModes = [ModeSettingEnum.Classic4P, ModeSettingEnum.Classic56P, ModeSettingEnum.Classic78P, ModeSettingEnum.CitiesAndKnights4P, ModeSettingEnum.CitiesAndKnights56P, ModeSettingEnum.ColonistRush4P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 37

    scenario = ScenarioSettingEnum.None
}
